function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.8237 20.6667C25.8237 22.508 24.222 24 22.2452 24H3.63739C1.66138 24 0.05896 22.508 0.05896 20.6667V3.33333C0.05896 1.492 1.66138 0 3.63739 0H22.2452C24.222 0 25.8237 1.492 25.8237 3.33333V20.6667Z",
  fill: "#3F51B5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3616 12.6667H17.9512V21.3333H14.3728V12.6667H12.2257V9.99999H14.3728V8.39332C14.3742 6.05466 15.417 4.66666 18.3749 4.66666H20.8139V7.33332H19.1772C18.0256 7.33332 17.9512 7.73332 17.9512 8.48199V9.99999H20.8139L20.3616 12.6667Z",
  fill: "white"
});

function SvgFacebookSignIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSignIn);
export default __webpack_public_path__ + "static/media/Facebook-SignIn.123b2669.svg";
export { ForwardRef as ReactComponent };